import { AutoAwesome } from "@mui/icons-material";
import { Button } from "@mui/material";

function AIActionButton({ label, disabled, onClick }) {
  return (
    <Button onClick={onClick} disabled={disabled} startIcon={<AutoAwesome />} variant="contained">
      {label}
    </Button>
  );
}

export default AIActionButton;
